import React from "react";
import { Stack, WarningMessage } from "sprint-common-web";

import { CloudFileStatus } from "../../common/types/CloudFileStatus";
import { useCloudFileDetails } from "../common/useCloudFileDetails";

export const CloudFileInQcDoneWarning = (): JSX.Element | null => {
    const { data: cloudFileDetails } = useCloudFileDetails();

    const isCloudFileInQcDone = cloudFileDetails?.status === CloudFileStatus.QcDone;

    if (!isCloudFileInQcDone) {
        return null;
    }

    return (
        <Stack style={{ marginBottom: 20 }}>
            <WarningMessage message="This cloud file has the status 'QC Done'. New assets have been created from this file." />
        </Stack>
    );
};
